<template>
    <v-container>
        <v-layout class="align-center justify-center">
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="teal">
                        <v-toolbar-title>Register</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        prepend-icon="person"
                                        name="firstName"
                                        label="First Name"
                                        type="text"
                                        autocomplete="given-name"
                                        v-model="formData.firstName"
                                        :rules="firstNameRules"
                                        required
                                    />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        prepend-icon="person"
                                        name="lastName"
                                        label="Last Name"
                                        type="text"
                                        autocomplete="family-name"
                                        v-model="formData.lastName"
                                        :rules="lastNameRules"
                                        required
                                    />
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-select
                                        prepend-icon="apartment"
                                        name="location"
                                        label="Location"
                                        v-model="formData.location"
                                        :rules="locationRules"
                                        :items="locationItems"
                                        item-text="location"
                                        item-value="uid"
                                        required
                                    />
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-text-field
                                        prepend-icon="person"
                                        name="email"
                                        label="Email"
                                        type="email"
                                        autocomplete="email"
                                        v-model="formData.email"
                                        :rules="emailRules"
                                        required
                                    />
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-text-field
                                        prepend-icon="lock"
                                        name="password"
                                        label="Password"
                                        id="password"
                                        type="password"
                                        autocomplete="new-password"
                                        required
                                        v-model="formData.password"
                                        :rules="passwordRules"
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" outlined to="/login">
                            Been here before?
                        </v-btn>
                        <v-spacer />
                        <v-btn
                            color="teal white--text"
                            :disabled="!valid"
                            @click="submit"
                        >
                            Register
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'Register',
    data() {
        return {
            valid: false,
            formData: {
                firstName: '',
                lastName: '',
                location: '',
                email: '',
                password: ''
            },
            firstNameRules: [v => !!v || "First name can't be blank"],
            lastNameRules: [v => !!v || "Last name can't be blank"],
            locationRules: [v => !!v || 'You must select a location'],
            emailRules: [
                v => !!v || 'Email is required',
                v => /.+@.+/.test(v) || 'Email must be valid'
            ],
            passwordRules: [
                v => !!v || 'Password is required',
                v => v.length >= 6 || 'Password must be at least 6 characters'
            ]
        };
    },
    computed: {
        locationItems() {
            return this.$store.state.locations;
        }
    },
    mounted() {
        this.initialize();
    },
    methods: {
        initialize() {
            this.getLocations();
        },

        getLocations() {
            this.$store.dispatch('locationRead');
        },

        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('userRegister', {
                    formData: this.formData
                });
            }
        }
    }
};
</script>
